import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerNotesCardSkeleton = () => (
  <Styles.Container>
    <Styles.SentimentRow>
      <Skeleton variant="text" width={140} height={20} />
      <Styles.BarPlaceholder>
        <Skeleton variant="rounded" width="100%" height={8} />
      </Styles.BarPlaceholder>
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={60} height={16} />
    </Styles.SentimentRow>

    <Styles.TopicRow>
      <Skeleton variant="text" width={20} height={20} />
      <Skeleton variant="text" width={180} height={20} />
      <Styles.BarPlaceholder>
        <Skeleton variant="rounded" width="100%" height={6} />
      </Styles.BarPlaceholder>
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={120} height={20} />
    </Styles.TopicRow>

    <Styles.TopicRow>
      <Skeleton variant="text" width={20} height={20} />
      <Skeleton variant="text" width={180} height={20} />
      <Styles.BarPlaceholder>
        <Skeleton variant="rounded" width="100%" height={6} />
      </Styles.BarPlaceholder>
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={120} height={20} />
    </Styles.TopicRow>

    <Styles.TopicRow>
      <Skeleton variant="text" width={20} height={20} />
      <Skeleton variant="text" width={180} height={20} />
      <Styles.BarPlaceholder>
        <Skeleton variant="rounded" width="100%" height={6} />
      </Styles.BarPlaceholder>
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={120} height={20} />
    </Styles.TopicRow>
  </Styles.Container>
)

export default CustomerNotesCardSkeleton
